let language = {
    STORE_PRODUCT_SETTING_FIX_PRICE_HEAD_PRICE_STRATEGY:"Price Strategy",
    STORE_PRODUCT_SETTING_FIX_PRICE_HEAD_WHITELABLE_PRICE:"Whitelabel Price",
    STORE_PRODUCT_SETTING_FIX_PRICE_HEAD_REVENUE:"Revenue",
    STORE_PRODUCT_SETTING_FIX_PRICE_HEAD_RETAIL_PRICE:"Retail price",
    STORE_PRODUCT_SETTING_FIX_PRICE_TYPE:"Fix price",
    STORE_PRODUCT_SETTING_FIX_PRICE_SET_REVENUE:"SET REVENUE",
    STORE_PRODUCT_SETTING_FIX_PRICE_REVENUE_CHANGE_TO:"Change To",
    STORE_PRODUCT_SETTING_FIX_PRICE_REVENUE_INCREASE_BY:"Increase By",
    STORE_PRODUCT_SETTING_FIX_PRICE_REVENUE_DECREASE_BY:"Decrease By",
};


export { language }